"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _useIntersectionObserver.default;
  }
});
var _useIntersectionObserver = _interopRequireDefault(require("./useIntersectionObserver"));
